import {
  executeSingleExport,
  runExportFlow,
  getFileTimestamp,
} from 'utils/importExport/bulkExport'
import exportStyles from '@/utils/importExport/style.module.scss'

const useRecordExport = (
  individual,
  { t, messageApi, setExportLoading, allowFileDownload = true },
) => {
  const handleExport = () => {
    const safeTitle = individual.title.replace(/[^a-zA-Z0-9가-힣ㄱ-ㅎㅏ-ㅣ_-]/g, '_')
    runExportFlow({
      defaultFilename: `${safeTitle}_${getFileTimestamp()}`,
      t,
      styles: exportStyles,
      messageApi,
      onExecute: ({ filename, password, onDestroyParentModals }) =>
        executeSingleExport({
          individual,
          filename,
          password,
          t,
          messageApi,
          setExportLoading,
          allowFileDownload,
          onDestroyParentModals,
        }),
    })
  }

  return { handleExport }
}

export default useRecordExport
